import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  Input,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
} from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-event-calendar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './event-calendar.component.html',
  styleUrls: ['./event-calendar.component.scss'],
})
export class EventCalendarComponent implements OnInit {
  // @Input() events: CalendarEvent[];
  @Input() events: any;

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  refresh: Subject<any> = new Subject();

  // events: CalendarEvent[] = [
  //   {
  //     start: new Date(),
  //     end: new Date(),
  //     title: 'Sample Event',
  //     color: colors.red,
  //     allDay: true
  //   }
  // ];

  user_details: any;

  activeDayIsOpen: boolean = false;

  constructor(
    private modal: NgbModal,
    private storageService: StorageService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.user_details = this.storageService.get('user_details');
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventClicked({
    date,
    events,
  }: {
    date: Date;
    events: CalendarEvent[];
  }): void {
    if (events.length > 0) {
      // this.handleEvent('Clicked', events);
      this.openDayEventModal({ date, events });
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: any): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  // addEvent(): void {
  //   this.events = [
  //     ...this.events,
  //     {
  //       title: 'New event',
  //       start: startOfDay(new Date()),
  //       end: endOfDay(new Date()),
  //       color: colors.red,
  //       draggable: true,
  //       resizable: {
  //         beforeStart: true,
  //         afterEnd: true,
  //       },
  //     },
  //   ];
  // }

  // deleteEvent(eventToDelete: CalendarEvent) {
  //   this.events = this.events.filter((event) => event !== eventToDelete);
  // }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  @ViewChild('dayEventsModal') dayEventsModal: TemplateRef<any>;
  private dayEventsModalRef: MatDialogRef<TemplateRef<any>>;

  selected_events_data: any = [];
  openDayEventModal(data) {
    this.selected_events_data = JSON.parse(JSON.stringify(data));
    this.dayEventsModalRef = this.dialog.open(this.dayEventsModal, {
      disableClose: true,
    });
    this.dayEventsModalRef.afterClosed().subscribe((result) => {
      this.closeDayEventModal();
    });
  }

  closeDayEventModal() {
    this.dayEventsModalRef.close();
    this.selected_events_data = {};
  }

  @ViewChild('specificEventsModal') specificEventsModal: TemplateRef<any>;
  private specificEventsModalRef: MatDialogRef<TemplateRef<any>>;
  specific_event_data: any = [];
  openSpecificEventModal(data) {
    this.specific_event_data = JSON.parse(JSON.stringify(data));
    this.specificEventsModalRef = this.dialog.open(this.specificEventsModal, {
      disableClose: true,
    });
    this.specificEventsModalRef.afterClosed().subscribe((result) => {
      this.closeSpecificEventModal();
    });
  }

  closeSpecificEventModal() {
    this.specificEventsModalRef.close();
    this.specific_event_data = {};
  }
}
